module.exports = __webpack_public_path__ + "img/logo-comune.59ef1803.png";